import Vue from "vue";
import Vuex from "vuex";
import api from "@/api";
import { Message } from "element-ui";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Record: {
      title: "浙ICP备14030516号-10",
      content: "Copyright© 2021 杭州汇合智能科技有限公司",
    },
    need: {},
    need_id: "",
    need_ids: "",
    Classes: [],
    conversationID: "",
    code: {},
    unionSendOrder:{}
  },
  getters: {},
  mutations: {
    unionSendOrder(state,data){
			state.unionSendOrder = data
		},
    SET_code(state, parent) {
      state.code = parent;
    },
    SET_need_id(state, parent) {
      state.need_id = parent;
    },
    SET_need(state, parent) {
      state.need = parent;
    },
    SET_need_ids(state, parent) {
      state.need_ids = parent;
    },
    SET_Classes(state, parent) {
      state.Classes = parent;
    },
    SET_Classes(state, parent) {
      state.Classes = parent;
    },
    SET_conversationID(state, parent) {
      state.conversationID = parent;
    },
  },
  actions: {
    GetClasses(state, parent) {
      api
        .get("user/mechanismCategory/queryListPageChild", {
          status: 2,
          type: 2,
          source: "体育宝",
        })
        .then((res) => {
          if (res.data.code == 0) {
            state.commit("SET_Classes", res.data.data);
          } else {
            Message({
              duration: 1000,
              message: "获取类目失败",
              type: "error",
            });
          }
        });
    },
    GetNeed(state, parent) {
      api
        .get("user/userCourseNeed/queryListPage", {
          coach_id: localStorage.getItem("coach_id"),
          create_type: 3,
          status: 1,
          id: parent,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let data = res.data.data[0];
            let payload = {
              data: "order",
              extension: JSON.stringify({
                amount: data.amount,
                categories: data.categories,
                title: data.title,
                id: data.id,
                service_type: data.service_type,
              }),
            };
            state.commit("SET_need", payload);
          }
        });
    },
  },
  modules: {},
});
